import React from "react";

export interface UsersData {
  name: string;
  role: string;
  emailAddress: string;
  status: React.ReactNode;
  action: React.ReactNode;
}

export const ColumnUsers = [
  {
    Header: "Name",
    accessor: "name",
  },
  {
    Header: "Role",
    accessor: "role",
  },
  {
    Header: "Email Address",
    accessor: "emailAddress",
  },
  {
    Header: "Status",
    accessor: "status",
  },
  {
    Header: "",
    accessor: "action",
  },
];
